import api from './axios';

export const login = (email, senha) => api.post('/auth/login', { email, senha });
export const me = () => api.get('/auth/me');
export const updateMe = (data) => api.patch('/auth/me', data);
export const alterarSenha = (senhaAtual, novaSenha) =>
  api.patch('/auth/me/senha', { senha_atual: senhaAtual, nova_senha: novaSenha });
